import axios from "../utils/axios";

export const customerRegistration = async (req) => {
  const response = await axios.post("/api/User/CreateCustomer", req);
  //console.log(response);
  return response.data;
};